export default async function _servicesMap() {
    // console.log('geoform');
    // Check if the module exists before doing anything
    const servicesMapComponentExists =
        !!document.querySelector('.services-map');

    // If the module exists, do whatever we need to
    if (servicesMapComponentExists) {
        // Your code here
        console.log('Services map custom JS');

        // ------------------------------------------
        // Install all the scripts
        // ------------------------------------------

        // Add Google Maps library and Place Autocomplete
        const loadGoogleMapScript = function () {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src =
                'https://maps.googleapis.com/maps/api/js?key=AIzaSyBOYJ_2mnQFQgTe5RfgvPD5ltiVCIXvvIQ&libraries=places'; // 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBOYJ_2mnQFQgTe5RfgvPD5ltiVCIXvvIQ&libraries=places&callback=initMap'
            document.body.appendChild(script);
            console.log('added google map script');
        };
        loadGoogleMapScript();

        // Add Marker Clusterer library
        const loadClustererScript = function () {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src =
                'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js';
            document.body.appendChild(script);
            console.log('added clusterer script');
        };
        loadClustererScript();

        // Add Overlapping Marker Spiderfier library
        const loadOverlappingScript = function () {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src =
                'https://cdnjs.cloudflare.com/ajax/libs/OverlappingMarkerSpiderfier/1.0.3/oms.min.js';
            document.body.appendChild(script);
            console.log('added overlapping script');
        };
        loadOverlappingScript();

        // Load Spatial API from SSC  https://geoserver.uat.ssc.nsw.gov.au/arcgis/rest/services/WebOnline/MapServer/4
        const getSpatialData = async (lat, lng) => {
            try {
                const url = `https://geoserver.ssc.nsw.gov.au/arcgis/rest/services/WebOnline/MapServer/4/query?geometry=${lng}%2C${lat}&geometryType=esriGeometryPoint&inSR=4326&spatialRel=esriSpatialRelIntersects&units=esriSRUnit_Meter&outFields=*&returnGeometry=false&f=json`;
                const res = await fetch(url);
                const data = await res.json();
                return data;
            } catch (err) {
                console.error(err);
                return err;
            }
        };

        // ------------------------------------------
        // Global data
        // ------------------------------------------
        // Dev URLs
        // const servicesMapUrl =
        //     'https://www.sutherlandshire.nsw.gov.au/_designs/item-builders/services-map-feed/';
        // const councillorsUrl =
        //     'https://www.sutherlandshire.nsw.gov.au/_designs/item-builders/councillors-feed/';
        // const markersUrl =
        //     'https://www.sutherlandshire.nsw.gov.au/_designs/item-builders/markers-feed/';

        // Prod URLs
        const servicesMapUrl = '/_designs/item-builders/services-map-feed/';
        const councillorsUrl = '/_designs/item-builders/councillors-feed/';
        const markersUrl = '/_designs/item-builders/markers-feed/';

        const urls = [servicesMapUrl, councillorsUrl, markersUrl];

        const allData = await Promise.all(
            urls.map(async (url) => {
                const res = await fetch(url);
                const data = res.json();
                return data;
            })
        );

        const locations = [...allData[0]];
        const councillors = [...allData[1]];
        const customMarkers = [...allData[2]];
        console.log('locations', locations);
        console.log('councillors', councillors);
        console.log('customMarkers', customMarkers);

        // ------------------------------------------
        // Variables
        // ------------------------------------------
        let map;
        let geoformLat;
        let geoformLng;
        let markers = [];
        const mapZoom = 16;
        const councilLat = -34.03034;
        const councilLng = 151.0597;
        const userGeoBtn = document.querySelector('.geoform-user-loc__btn');
        const geoformSubmitBtn = document.querySelector('.geoform-submit__btn');
        const autocompleteInput = document.querySelector(
            '.geoform-auto__input'
        );
        const spinnerEl = document.querySelector('.services-map__spinner');

        // ------------------------------------------
        // Collateral Functions
        // ------------------------------------------

        // Toggle search input in mobile
        const openSearchBtn = document.querySelector(
            '.services-map__button-open-search'
        );
        const searchInputContainer = document.querySelector(
            '.services-map__search-input-container'
        );
        const searchInput = document.querySelector('.geoform-auto__input');
        const closeSearchBtn = document.querySelector(
            '.services-map__button-close-search'
        );

        openSearchBtn.addEventListener('click', function () {
            this.style.display = 'none';
            searchInputContainer.style.display = 'block';
            searchInput.focus();
        });

        closeSearchBtn.addEventListener('click', function () {
            searchInputContainer.style.display = 'none';
            openSearchBtn.style.display = 'block';
        });

        // ------------------------------------------
        // Map Functions
        // ------------------------------------------

        const hideSpinner = function () {
            spinnerEl.style.display = 'none';
        };

        const displayMap = function (lat, lng) {
            map = new google.maps.Map(document.getElementById('servicesMap'), {
                center: { lat, lng },
                zoom: mapZoom,
            });
        };

        const loadMap = function () {
            if (window.location.search) {
                // Check url params
                console.log('yes', window.location.search);
                const urlParams = new URLSearchParams(window.location.search);
                const lat = +urlParams.get('lat');
                const lng = +urlParams.get('lng');
                console.log('urlParams', lat, lng);

                if (lat && lng) {
                    // Create Google maps using url params
                    displayMap(lat, lng);
                    hideSpinner();

                    const addressMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(lat, lng),
                        map,
                    });
                    console.log(addressMarker);

                    // Add address in location field
                    fetch(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBOYJ_2mnQFQgTe5RfgvPD5ltiVCIXvvIQ`
                    )
                        .then((response) => {
                            return response.json();
                        })
                        .then((data) => {
                            const address = data.results[0].formatted_address;
                            document.getElementById(
                                'geoform-autocomp__input'
                            ).value = address;
                        });

                    outputSpatialInfo(lat, lng); // eslint-disable-line no-use-before-define
                } else {
                    console.log('no lat lng');
                    // Create Google maps using default location (council office)
                    displayMap(councilLat, councilLng);
                    hideSpinner();
                    // Display council location
                    const councilMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(
                            councilLat,
                            councilLng
                        ),
                        map,
                    });
                    console.log(councilMarker);
                }
            } else {
                console.log('no url params');
                // Create Google maps using default location (council office)
                displayMap(councilLat, councilLng);
                hideSpinner();
                // Display council location
                const councilMarker = new google.maps.Marker({
                    position: new google.maps.LatLng(councilLat, councilLng),
                    map,
                });
                console.log(councilMarker);
            }
        };

        // Waste collection and councillors output functionality
        const outputSpatialInfo = function (lat, lng) {
            const spatialInfoEl = document.querySelector(
                '.services-map__spatial-info-box'
            );
            const generalWasteEl = document.querySelector(
                '.services-map__waste-general-date'
            );
            const recyclingWasteEl = document.querySelector(
                '.services-map__waste-recycling-date'
            );
            const gardenWasteEl = document.querySelector(
                '.services-map__waste-garden-date'
            );
            const councillorInfoEl = document.querySelector(
                '.services-map__councillors-info'
            );
            const councillorListEl = document.querySelector(
                '.services-map__councillors-list'
            );

            getSpatialData(lat, lng).then((data) => {
                console.log('spatial info', data.features);
                if (data.features.length) {
                    // Check if the location has data
                    const spatialData = data.features[0].attributes;
                    spatialInfoEl.style.display = 'block';

                    console.log('day', spatialData.DAY_OF_WEEK);
                    console.log('zone', spatialData.ZONE_NO);
                    console.log('test the inline script');

                    const WEEKDAYS = [
                        'Sunday',
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday',
                    ];

                    const dateOptions = {
                        weekday: 'short',
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                    };

                    const now = new Date();
                    console.log(
                        'Todays date:',
                        now.toLocaleDateString('en-au', dateOptions)
                    );

                    // Calculate the week number in the year to determine the green or yellow weeks...
                    const getWeek = function (date) {
                        const dateObj = new Date(date.getTime());
                        dateObj.setHours(0, 0, 0, 0);
                        // Thursday in current week decides the year.
                        dateObj.setDate(
                            dateObj.getDate() + 3 - ((dateObj.getDay() + 6) % 7)
                        );
                        // January 4 is always in week 1.
                        const week1 = new Date(dateObj.getFullYear(), 0, 4);
                        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
                        return (
                            1 +
                            Math.round(
                                ((dateObj.getTime() - week1.getTime()) /
                                    86400000 -
                                    3 +
                                    ((week1.getDay() + 6) % 7)) /
                                    7
                            )
                        );
                    };
                    const getNextDayOfWeek = function (
                        dayOfWeek,
                        additionalWeeks = 0,
                        date
                    ) {
                        const baseDate = date ? new Date(date) : new Date(); // Default to now if no date is passed
                        const currentDay = baseDate.getDay();
                        const distance = (dayOfWeek + 7 - currentDay) % 7 || 7; // Ensure day difference is not 0
                        baseDate.setDate(
                            baseDate.getDate() + distance + additionalWeeks * 7
                        );
                        return baseDate;
                    };

                    // const thisWeekNumber = getWeek(now);
                    // Get next date of a given day, with no additional week offset
                    const nextDayDate = getNextDayOfWeek(
                        WEEKDAYS.indexOf(spatialData.DAY_OF_WEEK),
                        0
                    );
                    const nextDay = nextDayDate.toLocaleDateString(
                        'en-au',
                        dateOptions
                    );
                    console.log('next day', nextDay);

                    // Get next date of a given day, with 1 additional week offset
                    const nextDayNextWeek = getNextDayOfWeek(
                        WEEKDAYS.indexOf(spatialData.DAY_OF_WEEK),
                        1
                    ).toLocaleDateString('en-au', dateOptions);
                    console.log('next day', nextDay);
                    console.log('next week day', nextDayNextWeek);

                    // Output the next general waste day (weekly)
                    generalWasteEl.innerHTML = nextDay;

                    // Output the next recycling or garden waste day (fortnightly)
                    if (getWeek(nextDayDate) % 2 === 0) {
                        // Week number even
                        console.log('week even');
                        if (spatialData.ZONE_NO === 1) {
                            console.log('next bin is yellow bin');
                            recyclingWasteEl.innerHTML = nextDay;
                            gardenWasteEl.innerHTML = nextDayNextWeek;
                        } else if (spatialData.ZONE_NO === 2) {
                            console.log('next bin is green bin');
                            gardenWasteEl.innerHTML = nextDay;
                            recyclingWasteEl.innerHTML = nextDayNextWeek;
                        }
                    } else {
                        // Week number odd
                        console.log('week odd');
                        if (spatialData.ZONE_NO === 1) {
                            console.log('next bin is green bin');
                            gardenWasteEl.innerHTML = nextDay;
                            recyclingWasteEl.innerHTML = nextDayNextWeek;
                        } else if (spatialData.ZONE_NO === 2) {
                            console.log('next bin is yellow bin');
                            recyclingWasteEl.innerHTML = nextDay;
                            gardenWasteEl.innerHTML = nextDayNextWeek;
                        }
                    }

                    // Create councillors list
                    console.log('Councillors');
                    const markup = `${spatialData.situ_ref} is in ${spatialData.ward} Ward.`;
                    councillorInfoEl.innerHTML = markup;

                    // Build the list of councillors
                    councillorListEl.innerHTML = '';
                    console.log(councillors);
                    councillors.map((person) => {
                        if (person.ward === spatialData.ward) {
                            const markupItem = `
                                <li class="services-map__councillor-item">
                                    <img src="${person.image}" alt="${person.name}" />
                                    <div>
                                        <h4><a href="${person.url}" target="_blank">${person.name}</a></h4>
                                        <p><span class="fi fi-sr-envelope" aria-hidden="true"></span><a href="mailto:${person.email}">${person.email}</a></p>
                                        <p><span class="fi fi-sr-phone-call" aria-hidden="true"></span><a href="tel:${person.phone}">${person.phone}</a></p>
                                        <p><span class="fi fi-sr-mailbox" aria-hidden="true"></span>${person.mailbox}</p>
                                        <p><span class="fi fi-sr-users-alt" aria-hidden="true"></span>${person.party}</p>
                                    </div>
                                </li>`;
                            councillorListEl.insertAdjacentHTML(
                                'beforeend',
                                markupItem
                            );
                        }
                        return councillors;
                    });
                } else {
                    // Clear the info if the location doesn't contain data
                    spatialInfoEl.style.display = 'none';
                    const selectors = [
                        generalWasteEl,
                        recyclingWasteEl,
                        gardenWasteEl,
                        councillorInfoEl,
                        councillorListEl,
                    ];
                    selectors.forEach((selector) => {
                        selector.innerHTML = ''; // eslint-disable-line no-param-reassign
                    });
                }
            });
        }; // /outputSpatialInfo

        // User geolocation
        const getUserLocation = function () {
            const options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            };

            document.querySelector('.lds-dual-ring').style.display = 'block';

            function success(pos) {
                const crd = pos.coords;

                console.log('Your current position is:');
                console.log(`Latitude : ${crd.latitude}`);
                console.log(`Longitude: ${crd.longitude}`);

                geoformLat = crd.latitude;
                geoformLng = crd.longitude;

                geoformSubmitBtn.disabled = false;

                // Add address in location field
                fetch(
                    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${geoformLat},${geoformLng}&key=AIzaSyBOYJ_2mnQFQgTe5RfgvPD5ltiVCIXvvIQ`
                )
                    .then((response) => {
                        return response.json();
                    })
                    .then((data) => {
                        const address = data.results[0].formatted_address;
                        document.getElementById(
                            'geoform-autocomp__input'
                        ).value = address;
                    });

                document.querySelector('.lds-dual-ring').style.display = 'none';

                // Submit the address
                geoformSubmitBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const userLocationMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(
                            geoformLat,
                            geoformLng
                        ),
                        map,
                    });
                    console.log(userLocationMarker);
                    // Move map center to address location
                    map.setCenter(userLocationMarker.getPosition());
                    map.setZoom(mapZoom);

                    outputSpatialInfo(geoformLat, geoformLng);
                });
            }

            function error(err) {
                console.warn(`ERROR(${err.code}): ${err.message}`);
            }

            navigator.geolocation.getCurrentPosition(success, error, options);
        };

        userGeoBtn.addEventListener('click', getUserLocation);

        // Place Autocomplete
        const options = {
            componentRestrictions: { country: 'au' },
        };
        const autocomplete = new google.maps.places.Autocomplete(
            autocompleteInput,
            options
        );

        autocomplete.addListener('place_changed', function () {
            const place = autocomplete.getPlace();
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();

            console.log('place', place);
            console.log('lat', latitude);
            console.log('lng', longitude);

            const addressMarker = new google.maps.Marker({
                position: new google.maps.LatLng(latitude, longitude),
                map,
            });
            console.log(addressMarker);

            geoformSubmitBtn.disabled = false;

            // Move map center to address location
            map.setCenter(addressMarker.getPosition());
            map.setZoom(mapZoom);
            // Get the spatial data
            outputSpatialInfo(latitude, longitude);

            // Submit the address
            geoformSubmitBtn.addEventListener('click', () => {
                // Move map center to address location
                map.setCenter(addressMarker.getPosition());
                map.setZoom(mapZoom);
                // Output spatial data
                outputSpatialInfo(latitude, longitude);
            });
        });

        // Map custom markers for each category
        const makeMarker = function (colourCat) {
            const { colour, svg, png } = customMarkers.filter(
                (item) => item.category === colourCat
            )[0];

            if (png) {
                return png;
            }
            return {
                path:
                    svg ||
                    'M66.9,41.8c0-11.3-9.1-20.4-20.4-20.4c-11.3,0-20.4,9.1-20.4,20.4c0,11.3,20.4,32.4,20.4,32.4S66.9,53.1,66.9,41.8z    M37,41.4c0-5.2,4.3-9.5,9.5-9.5c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5C41.3,50.9,37,46.6,37,41.4z',
                fillColor: colour,
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                scale: 0.6,
                anchor: new google.maps.Point(50, 50),
            };
        };

        // Filter the category to display
        const categoryList = [];
        const filterContainer = document.querySelector(
            '.services-map__filter-list'
        );
        locations.filter((item) => {
            if (
                !categoryList.includes(item.categoryCode) &&
                item.categoryCode !== ''
            ) {
                categoryList.push(item.categoryCode);
                const iconItem = customMarkers.filter(
                    (marker) => marker.category === item.categoryCode
                );

                const icon =
                    iconItem.length !== 0
                        ? iconItem[0].png
                        : '/__data/assets/image/0028/24796/placeholder.png';
                const markup = `
                    <li>
                        <input class="services-map__filter-checkbox" type="checkbox" id="${item.categoryCode}" name="${item.categoryCode}" value="${item.category}" checked="checked">
                        <label for="${item.categoryCode}">
                            ${item.category}
                            <img src="${icon}" alt="" style="width: 20px; margin-left: 4px; margin-top: 5px" />

                        </label>
                    </li>
                `;
                filterContainer.insertAdjacentHTML('beforeend', markup);
            }
            return locations;
        });

        console.log('categoryList', categoryList);

        // const filterContainer = document.querySelector(
        //     '.services-map__filter-list'
        // );

        // // Filtering out empty category code items
        // const validItems = locations.filter(item => item.categoryCode !== '');

        // // Setting unique category code list items
        // const uniqueItems = validItems.reduce((acc, curr) => {
        //     if(acc[curr.categoryCode]) return acc;
        //     acc[curr.categoryCode] = curr
        //     return acc;
        // }, {});

        // // Setting category codes items array
        // const items = Object.values(uniqueItems);

        // // Looping through categories and create markup
        // items.forEach(item => {
        //     const markup = `
        //         <li>
        //             <input class="services-map__filter-checkbox" type="checkbox" id="${item.categoryCode}" name="${item.categoryCode}" value="${item.category}" checked="checked">
        //             <label for="${item.categoryCode}">${item.category}</label>
        //         </li>
        //     `;
        //     filterContainer.insertAdjacentHTML('beforeend', markup);
        // });

        // console.log({items})

        // const categoryList = items.map(({categoryCode}) => categoryCode);
        // console.log({categoryList, items});

        // Filter the category to display
        let categoryState = [...categoryList]; // Keep track of category on and off

        // Alternative way to create markers: dividing the data to separate variables depending on category
        // This way the clusters will behave as expected (with markers visibility toggle; the cluster disregard the functionality and still appear but empty...)
        // 1/ Create the categories variables
        categoryList.forEach((cat) => {
            window[cat] = [];
        });

        // 2/ Populate the categories with the corresponding data
        locations.forEach((item) => {
            if (item.categoryCode !== '') {
                if (!window[item.categoryCode]) {
                    window[item.categoryCode] = [];
                }
                window[item.categoryCode].push(item);
            }
        });

        const initMap = function () {
            loadMap();

            const oms = new OverlappingMarkerSpiderfier(map, {
                markersWontMove: true,
                markersWontHide: true,
                basicFormatEvents: true,
            });

            const iw = new google.maps.InfoWindow();

            oms.addListener('click', function (pin, event) {
                iw.setContent(pin.desc);
                iw.open(map, pin);
                console.log(event);
            });

            oms.addListener('spiderfy', function () {
                iw.close();
            });

            const renderMarkers = function (markerArr, markerCat) {
                markerArr.forEach((item) => {
                    const markerInfo = `
                    <div>
                        <h4>${item.name}</h4>
                        ${
                            item.description !== ''
                                ? `<p>${item.description}</p>`
                                : ''
                        }
                        ${
                            item.eventTimeDate !== ''
                                ? `<p>${item.eventTimeDate}</p>`
                                : ''
                        }
                        ${item.address !== '' ? `<p>${item.address}</p>` : ''}
                        ${
                            item.parkFacilities !== ''
                                ? `<p>Facilities: ${item.parkFacilities}</p>`
                                : ''
                        }
                        <p><a href="${
                            item.url
                        }" target="_blank">Read more</a></p>
                        <p><a href="https://www.google.com/maps/dir/?api=1&destination=${
                            item.latitude
                        },${
                        item.longitude
                    }" target="_blank">Get directions</a></p>
                        </div>
                    `;

                    const marker = new google.maps.Marker({
                        position: new google.maps.LatLng(
                            item.latitude,
                            item.longitude
                        ),
                        icon: makeMarker(markerCat),
                        map,
                        title: item.name,
                        desc: markerInfo,
                        cat: item.categoryCode,
                    });
                    oms.addMarker(marker);

                    markers.push(marker); // Markers array is needed for clusters
                });
            };

            // 3/ Render the marker by categories and create clusters
            categoryList.forEach((cat) => {
                renderMarkers(window[cat], cat);
            });

            // Create clusters
            let cluster = new markerClusterer.MarkerClusterer({
                markers,
                map,
            });

            const checkboxes = document.querySelectorAll(
                '.services-map__filter-checkbox'
            );
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', (e) => {
                    console.log(e.target.checked);
                    const cat = e.target.getAttribute('id');

                    // Clear markers and clusters
                    markers = [];
                    cluster.clearMarkers();

                    if (e.target.checked === false) {
                        // Remove the category from the list of markers
                        const index = categoryState.indexOf(cat);
                        categoryState.splice(index, 1);
                        // Render markers on map
                        categoryState.forEach((category) => {
                            renderMarkers(window[category], category);
                        });
                        // Render clusters
                        cluster = new markerClusterer.MarkerClusterer({
                            markers,
                            map,
                        });
                    } else {
                        // Add the category in the list of markers
                        categoryState.push(cat);
                        // Render markers on map
                        categoryState.forEach((category) => {
                            renderMarkers(window[category], category);
                        });
                        // Render clusters
                        cluster = new markerClusterer.MarkerClusterer({
                            markers,
                            map,
                        });
                    }
                });
            });

            // Select and deselect all functionality
            const selectAllBtn = document.querySelector(
                '.services-map__button-select-all'
            );
            const deselectAllBtn = document.querySelector(
                '.services-map__button-deselect-all'
            );

            deselectAllBtn.addEventListener('click', function () {
                this.classList.toggle('show');
                selectAllBtn.classList.toggle('show');
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = false; // eslint-disable-line no-param-reassign
                    // Clear markers and clusters
                    markers = [];
                    cluster.clearMarkers();
                    categoryState = [];
                });
            });

            selectAllBtn.addEventListener('click', function () {
                console.log(this);
                this.classList.toggle('show');
                deselectAllBtn.classList.toggle('show');
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = true; // eslint-disable-line no-param-reassign
                });

                // Add all categories to the state manager
                categoryState = [...categoryList];
                // Add markers
                categoryState.forEach((cat) => {
                    renderMarkers(window[cat], cat);
                });
                // Render clusters
                cluster = new markerClusterer.MarkerClusterer({
                    markers,
                    map,
                });
            });
        };

        // Event listeners
        initMap();
    }
}
_servicesMap();
